export default function toSalusionPrivate(event, path = "", newWindow = true) {
    if (event) event.preventDefault()
    let hostname = window.location.hostname
    hostname = hostname.replace(/^www\./, "")
    path = path.replace(/^\/+/, "")

    let url
    if (path.includes("learning-center")) {
        url = `https://salusion.com/${path}`
    } else if (hostname === "localhost") {
        url = `http://localhost:8080/${path}`
    } else {
        url = `https://my.${hostname}/${path}`
    }

    if (newWindow) {
        window.open(url, "_blank")
    } else {
        window.location.href = url
    }
}

// using above code per Claude recommendation.  We can see how it works
// export default function toSalusionPrivate(event, path = "", newWindow = true) {
// 	if (event) event.preventDefault()

// 	let hostname = window.location.hostname
// 	hostname = hostname.replace(/^www\./, "")

// 	path = path.replace(/^\/+/, "")

// 	let target = "_self"
// 	if (newWindow) target = "_blank"
// 	if (path.includes("learning-center")) {
// 		window.open(`https://salusion.com/${path}`, target)
// 	} else if (hostname === "localhost") {
// 		window.open(`http://localhost:8080/${path}`, target)
// 	} else {
// 		window.open(`https://my.${hostname}/${path}`, target)
// 	}
// }
